import api from './api.service';

/**
 * Owner access/entitlements state (chantier 3A, saas/09).
 * - full    : accès complet.
 * - grace   : période expirée mais site public encore en grâce → back-office bloqué.
 * - expired : tout coupé.
 */
export type AccessLevel = 'full' | 'grace' | 'expired';

export interface AccessState {
  access: AccessLevel;
  status: string | null;
  free_until: string | null;
  grace_until: string | null;
  days_left: number;
}

export const accessService = {
  async getState(): Promise<AccessState> {
    const res = await api.get('/me/access');
    return res.data;
  },
};
